import { useAct } from 'FlowBuilder/store'
import './TopNav.scoped.scss'
import { useLanguagesData, useDefaultFlowLanguage } from '../hooks/useLanguageFlow'

export default function LanguageSelector() {
  const act = useAct()
  const defaultLanguage = useDefaultFlowLanguage()
  const [selectedLanguage, setSelectedLanguage] = useState(new URLSearchParams(window.location.search).get('lang') || defaultLanguage);

  const handleLanguageChange = (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('lang', event.target.value);
    setSelectedLanguage(event.target.value);
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
    act.local.setLanguage(event.target.value);
  }

  useEffect(() => {
    // On initial load, set url to language
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang') || defaultLanguage;
    act.local.setLanguage(urlLang);
  }, [defaultLanguage])

  const { editableLanguagesData } = useLanguagesData();

  if (Object.keys(editableLanguagesData).length <= 1) {
    return <></>
  }

  return (
    <select value={selectedLanguage} onChange={handleLanguageChange}>
      { Object.entries(editableLanguagesData).map(([lang, data]) => (
        <option key={lang} value={lang}>
          {data.flag} {data.name}
        </option>
      )) }
    </select>
  )
}
